import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import {
  createNoteByLcIdAndLevelId as createNoteByLcIdAndLevelIdService,
  deleteNote as deleteNoteService
} from '../../services/maestro/note.service.js'
import { handlerErrorV2 } from '../../utils/errors.jsx'
import { toggleAlertModule } from '../../store/actions/alert.actions.js'
import useMarking from './useMarking.js'

const useNote = () => {
  const { curriculumId, ulId } = useParams()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const student = useSelector((state) => state?.classMarking?.student)
  const { getStudentMarkingByClassIdAndUlId } = useMarking()

  const onUpdateFormData = () => {
    getStudentMarkingByClassIdAndUlId(student)
  }

  const formData = (form) => {
    return {
      comment: form.comment,
      media: form.media,
      ulId
    }
  }
  const createNoteByLcIdAndLevelId = async (studentId, lcId, levelId, gsId, form = {}) => {
    try {
      const data = formData(form)
      const response = await createNoteByLcIdAndLevelIdService(
        curriculumId,
        studentId,
        lcId,
        levelId,
        gsId,
        data
      )
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || 'An error ocurred'
        }
      } else {
        dispatch(toggleAlertModule())
        onUpdateFormData()
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const deleteNote = async (studentId, noteId) => {
    setIsLoading(true)
    try {
      const response = await deleteNoteService(curriculumId, studentId, noteId)
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || 'An error ocurred'
        }
      } else {
        onUpdateFormData()
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    createNoteByLcIdAndLevelId,
    deleteNote
  }
}

export default useNote
